import { render, staticRenderFns } from "./DirectReadCard.vue?vue&type=template&id=3eae3874&scoped=true"
import script from "./DirectReadCard.vue?vue&type=script&lang=js"
export * from "./DirectReadCard.vue?vue&type=script&lang=js"
import style0 from "./DirectReadCard.vue?vue&type=style&index=0&id=3eae3874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eae3874",
  null
  
)

export default component.exports